/** Phase F — Payment Account (USIO submerchant) shared helpers. Provisioning only: no money moves from these screens. */
import api from '../../lib/api';

export const paApi = {
  me: () => api.request('/payment-account/me'),
  prefill: () => api.request('/payment-account/me/prefill'),
  draft: (body) => api.request('/payment-account/me/draft', { method: 'PUT', body: JSON.stringify(body) }),
  authorize: (authorization_type) => api.request('/payment-account/me/authorizations', { method: 'POST', body: JSON.stringify({ authorization_type, consent: true }) }),
  submit: () => api.request('/payment-account/me/submit', { method: 'POST' }),
  clickToAgree: () => api.request('/payment-account/me/click-to-agree'),
  agreed: () => api.request('/payment-account/me/click-to-agree/completed', { method: 'POST' }),
  refresh: () => api.request('/payment-account/me/refresh', { method: 'POST' }),
  skip: () => api.request('/payment-account/me/skip', { method: 'POST' }),
};

export const INTENT_LABELS = {
  PAY_DOWNLINE: 'Pay Agents / Subagents', SEND_ACH_CREDITS: 'Send ACH credits',
  DEBIT_BUSINESS_CUSTOMERS: 'Debit business customers', ACCEPT_ACH_PAYMENTS: 'Accept ACH payments',
  ACCEPT_CARD_PAYMENTS: 'Accept card payments', CUSTOMER_BILLING: 'Customer / merchant billing',
};

export const CAPABILITY_LABELS = {
  SUBMERCHANT_ACCOUNT: 'Submerchant account', ACH_CREDIT: 'ACH credits', ACH_DEBIT: 'ACH debits',
  CARD_ACCEPTANCE: 'Card acceptance', DOWNLINE_PAYOUTS: 'Downline payouts', CUSTOMER_BILLING: 'Customer billing',
  ACCOUNT_VALIDATION: 'Account validation', SAME_DAY_ACH: 'Same-day ACH',
};

export const STATUS_COPY = {
  DRAFT: 'Draft — not submitted yet', SUBMITTED: 'Submitted to the provider', PROCESSING: 'Your application is being processed',
  ACTION_REQUIRED: 'Action required — review and accept the provider agreement', UNDER_REVIEW: 'Under provider risk review',
  APPROVED: 'Approved — finishing onboarding', ACTIVE: 'Active', DECLINED: 'Declined by the provider',
  SUSPENDED: 'Suspended', TERMINATED: 'Terminated', FAILED: 'Submission failed — you can try again',
};

export const getPath = (obj, path) => path.split('.').reduce((o, k) => (o && typeof o === 'object' ? o[k] : undefined), obj);

export const setPath = (obj, path, value) => {
  const next = JSON.parse(JSON.stringify(obj || {}));
  const parts = path.split('.');
  let cur = next;
  parts.slice(0, -1).forEach((p) => { cur[p] = cur[p] && typeof cur[p] === 'object' ? cur[p] : {}; cur = cur[p]; });
  cur[parts[parts.length - 1]] = value;
  return next;
};

export const tid = (path) => `pa-field-${path.replace(/\./g, '-')}`;

export const errorDetail = (e) => {
  const d = e?.lockoutData || e?.message;
  if (d && typeof d === 'object') {
    const extra = Array.isArray(d.details) ? d.details.map((x) => (typeof x === 'string' ? x : `${x.field}: ${x.message}`)).join(' · ') : '';
    return `${d.message}${extra ? ` — ${extra}` : ''}`;
  }
  return d || e?.message || 'That action could not be completed';
};
